import React, { useState } from "react";
import { useMediaPage } from "./hooks/useMediaPage";
import MediaList from "./components/MediaList";
import MediaFormModal from "./components/MediaFormModal";
import KioskLinksModal from "./components/KioskLinksModal";
import MediaBackgrounds from "./components/MediaBackgrounds";
import NeoLoader from "../../components/Common/NeoLoader";
import { NeoCard, NeoButton, NeoTabs, NeoDropdown } from "../../components/Common";
import { MEDIA_STATUS_TABS } from "./constants";
import { TabContent, TabPane } from "reactstrap";

/**
 * MediaPage
 * Rota: /totem/media (ou totem/gestao)
 * Gestão de mídias, campanhas e backgrounds do totem de autoatendimento.
 */
const MediaPage = () => {
    const [activeTab, setActiveTab] = useState('media');

    const {
        medias,
        isInitialLoading,
        statusFilter,
        setStatusFilter,
        isModalOpen,
        handleToggleModal,
        formState,
        isSaving,
        handleSave,
        handleEdit,
        handleDelete,
        isReady
    } = useMediaPage();

    if (!isReady || isInitialLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <NeoLoader type="inline" loading={true} />
            </div>
        );
    }

    const currentStatusLabel = MEDIA_STATUS_TABS.find(t => t.value === statusFilter)?.label || "Todos";

    const mainTabs = [
        { id: 'media', label: 'Campanha', icon: 'mdi-image-multiple' },
        { id: 'kiosk', label: 'Autoatendimento', icon: 'mdi-link-variant' },
        { id: 'background', label: 'Background', icon: 'mdi-wallpaper' }
    ];

    const dropdownItems = MEDIA_STATUS_TABS.map(tab => ({
        label: tab.label,
        onClick: () => setStatusFilter(tab.value),
        active: statusFilter === tab.value
    }));

    const headerActions = activeTab === 'media' ? (
        <NeoButton
            variant="primary"
            icon="mdi-plus"
            onClick={handleToggleModal}
        >
            Nova Mídia
        </NeoButton>
    ) : null;

    return (
        <React.Fragment>
            <NeoCard
                title="Gestão do Totem"
                subtitle="Campanhas de mídia, autoatendimento e planos de fundo"
                headerIcon="mdi-monitor-screenshot"
                headerActions={headerActions}
                thinBorder={true}
                className="border-0 animate__animated animate__fadeIn"
                bodyClassName="p-0"
            >
                {/* Tabs Principais */}
                <div className="border-bottom bg-white pt-2 px-4">
                    <NeoTabs
                        tabs={mainTabs}
                        activeTab={activeTab}
                        onChangeTab={setActiveTab}
                        variant="light"
                    />
                </div>

                <TabContent activeTab={activeTab}>
                    {/* TAB: Mídias */}
                    <TabPane tabId="media" className="animate__animated animate__fadeIn animate__faster">
                        {/* Filtro de Status em Dropdown */}
                        <div className="d-flex justify-content-end px-4 pt-3 pb-2">
                            <NeoDropdown
                                label={`Status: ${currentStatusLabel}`}
                                icon="mdi-filter-variant"
                                variant="outline-secondary"
                                items={dropdownItems}
                            />
                        </div>

                        {/* Lista de Mídias */}
                        <div className="px-4 pb-4">
                            <MediaList
                                medias={medias}
                                onSelect={handleEdit}
                                loading={false}
                            />
                        </div>
                    </TabPane>

                    {/* TAB: Autoatendimento (Links) */}
                    <TabPane tabId="kiosk" className="animate__animated animate__fadeIn animate__faster">
                        <div className="p-4">
                            <KioskLinksModal 
                                isOpen={true} 
                                toggle={() => {}} 
                                inline={true}
                            />
                        </div>
                    </TabPane>

                    {/* TAB: Background */}
                    <TabPane tabId="background" className="animate__animated animate__fadeIn animate__faster">
                        <MediaBackgrounds />
                    </TabPane>
                </TabContent>
            </NeoCard>

            {/* Modal de Formulário */}
            <MediaFormModal
                isOpen={isModalOpen}
                toggle={handleToggleModal}
                data={formState}
                onSave={handleSave}
                onDelete={handleDelete}
                isSaving={isSaving}
            />
        </React.Fragment>
    );
};

export default MediaPage;
